export const Accordion = () => {
    const faqSection = document.querySelectorAll('.faq-section');

    if (faqSection.length > 0) {
        faqSection.forEach(section => {
            const accordionItems = section.querySelectorAll('.faq-section__items');

            accordionItems.forEach(item => {
                const content = item.querySelector('.faq-section__collapse');
                const button = item.querySelector('.faq-section__header button');

                button.addEventListener('click', () => {
                    item.classList.toggle('opened');
                    if (button.getAttribute('aria-expanded') === "false") {
                        content.style.maxHeight = content.scrollHeight + 150 + "px";
                        button.setAttribute('aria-expanded', 'true')
                    } else {
                        content.style.maxHeight = null;
                        button.setAttribute('aria-expanded', 'false')
                    }

                });

            });

        });
    }


}